import _ from "lodash";

export default {    
    isActiveFreebee: state => state.isActiveFreebee,
    isActiveFreebeePromotion: state => state.isActiveFreebeePromotion,
    freebeeItems: state => _.cloneDeep(state.freebeeItems),
    mobile: state => state.mobile,
    campaigns: state => _.cloneDeep(state.campaigns),
}